<div class="particles-container flex items-center justify-center">
  <ngx-particles
    id="trade-modal-particles"
    [options]="particlesOptions"
  ></ngx-particles>
</div>
<svg-icon
  class="trade--steam-icon"
  [svgStyle]="{ width: '40px', height: '40px', fill: 'var(--yellow)' }"
  src="assets/icons/ui/steam.svg"
/>
<h2 class="trade--title typography-title">Your trade has been sent</h2>
<p class="trade--description" style="color: var(--gray)">
  Accept the trade offer to {{ tradeModalOptions().typography_trade_for }} for
  <app-cost [balanceType]="balance()" [cost]="tradeSkinsCost()" [gap]="4"></app-cost>
</p>
<div class="trade--items">
  @for (item of tradeModalOptions().trade_skins.slice(0, 4); track $index) {
  <div class="trade--item box-white-04 hover">
    <img [src]="item.image" [alt]="item.name" loading="lazy" />
  </div>
  } @let remainingSkins = tradeModalOptions().trade_skins.length - 4; @if
  (remainingSkins > 0) {
  <div class="trade--item box-yellow-08 hover" style="cursor: pointer">
    +{{ remainingSkins }}
  </div>
  }
</div>
<a
  [href]="`https://steamcommunity.com/tradeoffer/${tradeModalOptions().trade_offer_id}/`"
  target="_blank"
  class="trade--button button button--style-yellow padding-x-12 h-38"
>
  Accept Trade Offer
</a>
<span class="trade--hash"
  >Trade Hash: {{ tradeModalOptions().trade_hash }}</span
>
